var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"mb-3"},[_c('h2',{staticClass:"text-yellow-200"},[_vm._v("Oops. Wrong guess")])])])}]

export { render, staticRenderFns }